import React from 'react';
import { Route, Redirect, Switch } from "react-router-dom";
import './css/main.css';
import Sidebar from './Sidebar';
import Page from './Page';
import content from './notes/index.js';


function App() {

  let expand_tree = (e, base_path) => {
    if (e.folder) {
      return e.items.map((item) => expand_tree(item, base_path + e.path + '/'))
    }
    else {
      const path = base_path + e.path;
      return (
        <Route path={path} key={path} >
          <Page content={require('.' + path + '.md')} title={e.name} />
        </Route >
      );
    }
  }

  const routes = content.map((item) => expand_tree(item, '/notes/'))

  return (
    <>
      <div className="flex flex-row">
        <Sidebar />
        <Switch>
          <Route exact path='/notes'>
            <Redirect to='/notes/about' />
          </Route>
          {routes}
        </Switch>
      </div>
    </>
  );
}



export default App;
